/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 11:31:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-20 16:03:13
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/TimeAndDatePickField/TimeAndDatePicker/index.tsx
 */
import React from 'react';
//import styles from './css.module.less';
import moment, { Moment } from 'moment';
import styles from './css.module.less';
import cls from 'classnames';
import TimerPickerModal from '../Components/TimePickerModal';
import {
  handleOnGetCurrentSCDateFormat,
  handleOnGetCurrentSCTimeFormat,
} from '@/src/tools/tools';

const TimeAndDatePickerField = (props) => {
  const [visible, setVisible] = React.useState(false);
  const resetTimeModal = () => void 0;
  // occupiedRange.push({ beginDate, beginTime, endDate, endTime });
  const { timeZone, occupiedRange = [], data, onChange, disabled } = props;
  const { startTime, endTime } = data || {};
  const openModal = () => {
    if (disabled) return;
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };
  const handleSubmitTimeModal = (start: Moment, end: Moment) => {
    if (onChange) {
      onChange({ startTime: start, endTime: end });
    }
    closeModal();
  };

  const DateFormat =
    `${handleOnGetCurrentSCDateFormat()} ${handleOnGetCurrentSCTimeFormat()}` ||
    'DD MMM YY, HH:mm';

  return (
    <React.Fragment>
      <TimerPickerModal
        visible={visible}
        onCancel={closeModal}
        onSubmit={handleSubmitTimeModal}
        afterClose={resetTimeModal}
        occupiedRanges={occupiedRange}
        timezoneGmt={timeZone}
        date={data}
      />
      <div className={styles.timeDisplay}>
        <div className={cls(styles.title, { [styles.disabled]: disabled })}>
          {`Start Time (${timeZone})`}
        </div>
        <div className={cls(styles.time, { [styles.disabled]: disabled })}>
          {startTime ? moment(startTime).format(DateFormat) : '-'}
        </div>
      </div>
      <div className={styles.timeDisplay}>
        <div className={cls(styles.title, { [styles.disabled]: disabled })}>
          {`End Time (${timeZone})`}
        </div>
        <div className={cls(styles.time, { [styles.disabled]: disabled })}>
          {endTime ? moment(endTime).format(DateFormat) : '-'}
        </div>
      </div>
      <div
        className={cls(styles.timeSetting, { [styles.disabled]: disabled })}
        onClick={openModal}>
        Edit Start and End Time
      </div>
    </React.Fragment>
  );
};
export default TimeAndDatePickerField;
